import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "market-app" }

import MessageCenter from "@/components/MessageCenter/index.vue";
import useUserStore from "@/store/modules/user";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const userStore = useUserStore();

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    (_unref(userStore).token)
      ? (_openBlock(), _createBlock(MessageCenter, {
          key: _unref(userStore).token
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})